<template>
 <div>
  <div id="agreeDialog" :style="{'width':rootWidth, 'height': rootHeight}">
    <div id="dialogTitleDiv">
      <span style="font-size:large;font-weight:bold">{{$store.state.showAgreeTitle}}</span>
      <img style="width:20px;height:20px;position:absolute;right:15px" id="dialogCloseImg" src="~assets/img/cplan/close.png" @click="dialogClose()"/>
    </div>
    <iframe id="dialogIframe" :src="$store.state.showAgreeUrl" :style="{'width':rootWidth, 'height': rootHeight}"></iframe>
  </div>
 </div>
</template>

<script>
 export default {
  props:{
    showDialogInCenterPage:false
  },
   data () {
     return {
      rootWidth: "100vw",
      rootHeight: "100vh",
     }
   },
   mounted:function() {
    // 获取rid等信息
    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.state.commonParameters;

    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] === 'true' && this.showDialogInCenterPage) {
      this.rootHeight = "150vh"
      this.rootWidth = "65vw"
    }
   },
   methods:{
    dialogClose(){
      this.$store.commit("updateShowAgreeDialogStatus", false);
      // 已经打开对话框，安卓端按返回键应该要拦截不处理，这个是个小优化
      this.sendToCPlanClient('closeAgreeDialog?')
    }
   }
 }
</script>

<style>

#agreeDialog{
  /* width: 100%;
  height: 100%; */
  position: absolute;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  z-index: 2233;
  top: 0;
  left: 0;

}
#dialogTitleDiv{
  margin-top: 5px;
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
#dialogIframe{
  margin-top: 20px;
  /* width: 100vw;
  height: 100vh; */
  font-size: small;
  border: none;
  overflow-x: hidden;
  overflow-y: scroll;
  /* transform-origin: 0 0;
  transform: scale(1 1.5); */
}
 
</style>


// WEBPACK FOOTER //
// src/views/CPlan/login/agreeProtocol/AgreeDialog.vue